import Cookies from 'cookies-js';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cdn } from '../../helpers/urls';

const COOKIE_WARNING_EXPIRY = 365 * 24 * 3600;
const COOKIE_ADVANCED_FILTER_HELP = 'wayke-advanced-filter-help-cookie';

const getCookie = () => {
  return !!Cookies.get(COOKIE_ADVANCED_FILTER_HELP);
};

const setCookie = () => {
  Cookies.set(COOKIE_ADVANCED_FILTER_HELP, true, { expires: COOKIE_WARNING_EXPIRY });
  return true;
};

const AdvancedFilterHelp = () => {
  const { t } = useTranslation('search');
  const [visible, setVisible] = useState(!getCookie());
  const [expanded, setExpanded] = useState(false);
  const onHide = useCallback(() => {
    setVisible(false);
    setCookie();
  }, []);

  if (!visible) return null;

  return (
    <div className="filter-panel-body-header-section">
      <div data-wx-alert="info">
        <div className="alert-icon-section">
          <div className="alert-icon">
            <i className="icon-info no-margin" />
          </div>
        </div>
        <div className="alert-content">
          <div className="font-medium">{t('Exclude from search', { ns: 'search' })}</div>
          <div>
            <button
              type="button"
              title=""
              data-am-link="font-inherit"
              className="l-block"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? t('Hide example', { ns: 'search' }) : t('Show example', { ns: 'search' })}
            </button>
          </div>
          {expanded && (
            <div className="m-t-half">
              {t(
                'In addition to adding to your search, you can exclude from your search. For example: all gray cars.',
                { ns: 'search' },
              )}
              <picture className="l-block l-full m-t-half">
                <source
                  media="(max-width: 399px)"
                  srcSet={cdn('/images/filter-panel/filter-panel-exclude-help-mobile.png')}
                />
                <source
                  media="(min-width: 400px)"
                  srcSet={cdn('/images/filter-panel/filter-panel-exclude-help-desktop.png')}
                />
                <img
                  srcSet={cdn('/images/filter-panel/filter-panel-exclude-help-desktop.png')}
                  alt={t('Negative filters', { ns: 'search' })}
                  className="l-block l-full m-t-half"
                />
              </picture>
            </div>
          )}
        </div>
        <div className="alert-close">
          <button
            type="button"
            className="alert-close-btn"
            onClick={onHide}
            title={t('Close tips', { ns: 'search' })}
          >
            <i className="icon-close no-margin" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdvancedFilterHelp;
